import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  isActive?: boolean;
}

const AvatarIcon: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  isActive = false,
  ...props
}) => (
  <svg
    width="18"
    height="15"
    viewBox="0 0 18 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.37085 0.140022C4.4619 0.079272 4.56402 0.0370528 4.67138 0.0157756C4.77875 -0.00550168 4.88925 -0.00542022 4.99659 0.0160154C5.10392 0.037451 5.20598 0.0798208 5.29693 0.140705C5.38789 0.201589 5.46596 0.279795 5.52669 0.370855L6.94585 2.50002H11.0542L12.4734 0.370855C12.5341 0.279805 12.6122 0.20161 12.7031 0.140734C12.7941 0.0798575 12.8961 0.0374926 13.0035 0.0160577C13.1108 -0.00537715 13.2213 -0.00546226 13.3287 0.0158076C13.436 0.0370774 13.5381 0.0792855 13.6292 0.140022C13.7202 0.200758 13.7984 0.278833 13.8593 0.36979C13.9202 0.460746 13.9626 0.562802 13.984 0.670131C14.0054 0.777461 14.0055 0.887961 13.9842 0.995322C13.963 1.10268 13.9208 1.20481 13.86 1.29586L13.0584 2.50002H14C14.8841 2.50002 15.7319 2.85121 16.357 3.47633C16.9822 4.10145 17.3334 4.9493 17.3334 5.83335V11.6667C17.3334 12.5507 16.9822 13.3986 16.357 14.0237C15.7319 14.6488 14.8841 15 14 15H4.00002C3.11597 15 2.26812 14.6488 1.643 14.0237C1.01788 13.3986 0.666687 12.5507 0.666687 11.6667V5.83335C0.666687 4.9493 1.01788 4.10145 1.643 3.47633C2.26812 2.85121 3.11597 2.50002 4.00002 2.50002H4.94252L4.14002 1.29586C4.07927 1.20481 4.03705 1.10269 4.01577 0.995324C3.9945 0.88796 3.99458 0.777456 4.01601 0.670123C4.03745 0.56279 4.07982 0.460731 4.1407 0.369776C4.20159 0.27882 4.27979 0.200749 4.37085 0.140022ZM6.48835 4.16669H4.00002C3.55799 4.16669 3.13407 4.34228 2.82151 4.65484C2.50895 4.9674 2.33335 5.39133 2.33335 5.83335V11.6667C2.33335 12.1087 2.50895 12.5326 2.82151 12.8452C3.13407 13.1578 3.55799 13.3334 4.00002 13.3334H14C14.442 13.3334 14.866 13.1578 15.1785 12.8452C15.4911 12.5326 15.6667 12.1087 15.6667 11.6667V5.83335C15.6667 5.39133 15.4911 4.9674 15.1785 4.65484C14.866 4.34228 14.442 4.16669 14 4.16669H6.51335H6.48835ZM6.50002 6.66669C6.72103 6.66669 6.933 6.75449 7.08928 6.91077C7.24556 7.06705 7.33335 7.27901 7.33335 7.50002V9.16669C7.33335 9.3877 7.24556 9.59966 7.08928 9.75594C6.933 9.91222 6.72103 10 6.50002 10C6.27901 10 6.06705 9.91222 5.91077 9.75594C5.75448 9.59966 5.66669 9.3877 5.66669 9.16669V7.50002C5.66669 7.27901 5.75448 7.06705 5.91077 6.91077C6.06705 6.75449 6.27901 6.66669 6.50002 6.66669ZM11.5 6.66669C11.721 6.66669 11.933 6.75449 12.0893 6.91077C12.2456 7.06705 12.3334 7.27901 12.3334 7.50002V9.16669C12.3334 9.3877 12.2456 9.59966 12.0893 9.75594C11.933 9.91222 11.721 10 11.5 10C11.279 10 11.067 9.91222 10.9108 9.75594C10.7545 9.59966 10.6667 9.3877 10.6667 9.16669V7.50002C10.6667 7.27901 10.7545 7.06705 10.9108 6.91077C11.067 6.75449 11.279 6.66669 11.5 6.66669Z"
      fill={isActive ? 'url(#gradient)' : '#333333'}
    />
    {isActive && (
      <defs>
        <linearGradient
          id="gradient"
          x1="0.666687"
          y1="7.49995"
          x2="17.1093"
          y2="5.58068"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FD84BE" />
          <stop offset="0.5" stopColor="#FB7BDB" />
          <stop offset="1" stopColor="#BF78F2" />
        </linearGradient>
      </defs>
    )}
  </svg>
);

export default AvatarIcon;
